module.exports = __webpack_public_path__ + "static/media/32_CORTININHA_DE_BABADO_COM_BOJO_LISA_01.12ba3603.jpg";